import { useEffect, useState } from 'react';

import { useImportPartsActions } from 'partsOld/hooks';
import {
  mapOmitsToSend,
  mapUnknownManufacturersToValue,
  mapUnknownManufacturersToSend,
} from 'partsOld/mappers';

import { IManufacturer } from 'partsOld/types';

import UnkownManufacturerModalView from './UnkownManufacturerModalView';

interface IProps {
  isOpen: boolean;
  unknownManufacturers: string[];
  partImport: number;
  refetchValidateParts;
}

const UnkownManufacturerModal = ({
  isOpen,
  unknownManufacturers,
  partImport,
  refetchValidateParts,
}: IProps) => {
  const [manufacturers, setManufacturers] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [omits, setOmits] = useState(null);

  const onSuccess = () => setIsModalOpen(false);

  const { importSaveManufacturers } = useImportPartsActions(onSuccess);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setManufacturers(mapUnknownManufacturersToValue(unknownManufacturers, null));
    setOmits(mapUnknownManufacturersToValue(unknownManufacturers, true));
  }, [unknownManufacturers]);

  const onManufacturerChange = (value: IManufacturer, unknownManufacturer: string) => {
    setManufacturers({ ...manufacturers, [unknownManufacturer]: value });
    setOmits({ ...omits, [unknownManufacturer]: false });
  };

  const onOmitChange = (unknownManufacturer: string) => {
    setOmits({ ...omits, [unknownManufacturer]: !omits[unknownManufacturer] });
    setManufacturers({ ...manufacturers, [unknownManufacturer]: null });
  };

  const onSave = async () => {
    await importSaveManufacturers({
      partImport,
      map: mapUnknownManufacturersToSend(manufacturers),
      omit: mapOmitsToSend(omits),
    });

    refetchValidateParts();
  };

  return (
    <UnkownManufacturerModalView
      onManufacturerChange={onManufacturerChange}
      onOmitChange={onOmitChange}
      manufacturers={manufacturers}
      omits={omits}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      onSave={onSave}
      unknownManufacturers={unknownManufacturers}
    />
  );
};

export default UnkownManufacturerModal;
